'use server'

import { Toast } from './Toast'
import { ToastProps } from './types'

export const ToastProvider = async ({
  children,
  props,
}: {
  children: React.ReactNode
  props?: ToastProps
}) => {
  return (
    <>
      <Toast {...props} />
      {children}
    </>
  )
}
